import React from 'react';
import DropdownTab from '../../components/dropdown-tab';
import PageLayout from '../../layouts/pagelayout';
import OperationalExcellence from '../../content/awards-and-accolades/operational-excellence';
import SustainabilityAndCsr from '../../content/awards-and-accolades/sustainability-&-csr';
import EnvironmentalPractices from '../../content/awards-and-accolades/environmental-practices';
import TransformationAndInnovation from '../../content/awards-and-accolades/transformation-&-innovation';
import LeadershipExcellence from '../../content/awards-and-accolades/leadership-excellence';
import PeoplePractices from '../../content/awards-and-accolades/people-practices';
import TechnologicalDistinction from '../../content/awards-and-accolades/technological-distinction ';
import SectionTitle from '../../components/section-title';
import CustomImage from '../../components/custom-image';
import BreadCrumb from '../../components/breadcrumb';
import ScrollPositionAnimation from '../../components/scrollpositionanimation';

interface Props {}
interface State {
  tabs: any;
  setActive: any;
}

class AwardsAndAccolades extends React.Component<Props, State> {
  myRef;
  constructor(props) {
    super(props);
    this.state = {
      tabs: [
        { id: 1, title: 'Operational Excellence', isActive: true, source: () => <OperationalExcellence /> },
        { id: 2, title: 'Sustainability & CSR', isActive: false, source: () => <SustainabilityAndCsr /> },
        { id: 3, title: 'Environmental Practices', isActive: false, source: () => <EnvironmentalPractices /> },
        {
          id: 4,
          title: 'Transformation & Innovation',
          isActive: false,
          source: () => <TransformationAndInnovation />,
        },
        { id: 5, title: 'Leadership Excellence', isActive: false, source: () => <LeadershipExcellence /> },
        { id: 6, title: 'People Practices', isActive: false, source: () => <PeoplePractices /> },
        { id: 7, title: 'Technological Distinction', isActive: false, source: () => <TechnologicalDistinction /> },
      ],
      setActive: 1,
    };
     this.myRef = React.createRef();
  }

  renderTabs = () => {
    const { setActive, tabs } = this.state;
    return (
      <div className="tab">
        {tabs.map((tab, index) => {
          return (
            <div
              key={index}
              className={`tablinks ${setActive == tab.id ? 'is-active' : ''}`}
              // onClick={() => this.setState({ setActive: tab.id })}
              onClick={() => this.handleOnClick(tab.id)}
            >
              {tab.title}
            </div>
          );
        })}
      </div>
    );
  };

  handleOnClick = (id) => {
    this.setState({ setActive: id });
    this.scrollToTop();
  };

  // General scroll to element function
  scrollToTop = () => {
    window.scroll({
      top: this.myRef.current.getBoundingClientRect().top + window.pageYOffset - 90,
      behavior: 'smooth',
    });
  };

  render() {
    const { setActive, tabs } = this.state;
    return (
      <PageLayout pageTitle="Vedanta - Awards and Accolades" pageLink="/overview/awards-and-accolades">
        <div className="awards-container">
          <div className="awards-container-inner">
            <div className="desktop-tab">
              <div className="left-menu">
                <div className="menu-list">
                  <h3>Awards and Accolades</h3>
                  {this.renderTabs()}
                </div>
              </div>
            </div>
            <div ref={this.myRef} className="right-content">
              <div className="awards-content top-section">
                <BreadCrumb />
                <ScrollPositionAnimation targetElement1="anim-1" targetElement2="anim-2">
                  <div className="two-col">
                    <div className="left-col">
                      <div className="left-to-right anim-1">
                        <SectionTitle
                          label="Awards and accolades"
                          lighttext="Recognitions"
                          boldtext="That set us apart"
                          iconimage="award-icon.png"
                          alt="operational-excellence"
                        ></SectionTitle>
                        <p>
                          The Executive Committee, led by the Chief Executive Officer assumes responsibility for the
                          day-to-day operations and apprises the Board of the key developments, assisting them in
                          setting our overall strategic direction.
                        </p>
                      </div>
                    </div>
                    <div className="right-col">
                      <div className="bottom-to-top anim-2">
                        <div className="desktop-tab">
                          <CustomImage
                            imageName="operational-excellence-img.jpg"
                            alt="operational-excellence-img"
                            maxWidth="507"
                          />
                        </div>
                        <div className="mobile-tab">
                          <CustomImage
                            imageName="operational-excellence-img-m.jpg"
                            alt="operational-excellence-img"
                            maxWidth="991"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </ScrollPositionAnimation>
              </div>
              <div className="mobile-tab bottom-section">
                <DropdownTab data={tabs} isScrollTo={true}/>
              </div>

              <ScrollPositionAnimation targetElement2="anim-3">
                <div className="desktop-tab">
                  <div className="bottom-to-top anim-3">{tabs.find((tab) => tab.id === setActive).source()}</div>
                </div>
              </ScrollPositionAnimation>
            </div>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default AwardsAndAccolades;
